import { createFileRoute } from '@tanstack/react-router'
import { ProtectedRoute } from '../components/protected-route'
import { OrganizationProvider } from '../components/OrganizationProvider'
import RootLayout from '../layouts/RootLayout'

export const Route = createFileRoute('/_protected')({
  component: ProtectedLayout,
})

function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <OrganizationProvider>
        <RootLayout />
      </OrganizationProvider>
    </ProtectedRoute>
  )
}